import $ from "jquery";

$(".arrowdown").on("click", function(e) {
    $('html, body').animate({
        scrollTop: $(this).parent().next().offset().top  - 0
    }, 800);
});